import { showPostActionSheet } from '../../../actions/one-app';
import { getPostByIdOrSlug } from '../../../selectors/post-selectors';
import { isOneAppShareSupported } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { NAV_BUTTON_VALUES } from '../constants';
import createMessageHandler from './create-message-hander';

export default createMessageHandler({
  [NAV_BUTTON_VALUES.POST_MENU]: ({ message, ...rest }) => (dispatch, getState) => {
    const { postId } = message.data.value;
    const post = getPostByIdOrSlug(getState(), postId);
    const enableShare = isOneAppShareSupported(getState());

    dispatch(showPostActionSheet({ post, message, enableShare, ...rest }));
  },
});
